import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Mail from './mail';
export default (
  <Route path="mail">
    <IndexRoute component={(props) => <Mail {...props} />} />
  </Route>
);
